<template>
  <div>
    <GNavBar></GNavBar>
    <h1 class="mt-5 pt-5">CoursePrep</h1>
    <div v-if="loading">
      <LoadingScreen></LoadingScreen>
    </div>
    <b-row v-else align-h="center">
      <b-col md="12">
        <Announcements
          v-if="announcements.length > 0"
          class="mb-3"
          :annArray="announcements"
        ></Announcements>
        <h2>🚧 Almost there...</h2>
        <p>
          We are currently loading courses from CUNYFirst. We expect to go live
          in 24 to 48 hours. Thank you for your patience.
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import GNavBar from '@/components/GNavBar.vue'
  import LoadingScreen from '@/components/LoadingScreen'
  import Announcements from '@/components/Announcements'

  export default {
    name: 'CoursePrepPage',
    async created() {
      await this.getData()
      await this.$store.dispatch('setup')
    },
    beforeDestroy() {
      clearInterval(this.polling)
    },
    data() {
      return {
        polling: null,
      }
    },
    computed: {
      currentUser() {
        return this.$store.getters.currentUser
      },
      displayComp() {
        return this.$store.getters.cp_displayComp
      },
      loading() {
        return this.$store.getters.loadingStatus
      },
      announcements() {
        return this.$store.getters.announcements.filter(a => a.module === 'cp')
      },
    },
    components: {
      GNavBar,
      LoadingScreen,
      Announcements,
    },
    methods: {
      async getData() {
        this.$store.commit('updateLoadingStatus', true)
        try {
          const sections = await this.$store.dispatch('cp_callAPI', {
            url: `/p/sections`,
          })
          const sectionComments = await this.$store.dispatch('cp_callAPI', {
            url: `/p/section_notes`,
          })
          const courseComments = await this.$store.dispatch('cp_callAPI', {
            url: `/p/course_notes`,
          })
          this.$store.commit('cp_updateSectionInfo', sections)
          this.$store.commit('cp_updateSectionComments', sectionComments)
          this.$store.commit('cp_updateCourseComments', courseComments)
        } catch (err) {
          this.$router.push({
            name: 'error',
            params: {
              title: 'Networking issue',
              message: err.message,
              errObj: this.$store.getters.currentUser,
            },
          })
        } finally {
          this.$store.commit('updateLoadingStatus', false)
        }
      },
    },
  }
</script>
<style>
  .component-fade-enter-active,
  .component-fade-leave-active {
    transition: opacity 0.2s ease;
  }
  .component-fade-enter,
  .component-fade-leave-to {
    opacity: 0;
  }
</style>
